import React from 'react';
import { connect } from 'react-redux';
import {
  StyledForm,
  FormGroup,
  UpgradeText,
  ChannelFormSection,
  FieldHead,
  UpgradeButtonLink,
  UpgradeButtonLinkContainer,
} from "./styledComponents";
import Button from 'components/Button';
import { toast, ToastContainer } from 'react-toastify';
import { Field, formValueSelector } from 'redux-form';
import { ChannelInputField } from './components';
import Divider from 'components/Divider';
import { colors } from 'globalStyles';

const notify = () => toast("Changes Saved!");
export const TermsForm = ({
  edit,
  submitting,
  handleSubmit,
  termsText,
  permissionRole,
}) => {
  return (
    <StyledForm onSubmit={handleSubmit}>
      <ToastContainer />
      <FormGroup>
        <ChannelFormSection>
          <FieldHead className="brand">
            <strong>Custom Guest Terms</strong>
            <h3 className="customize-the-message">
              Add custom guest policies to Movebooth's standard{" "}
              <a
                href="https://movebooth.com/terms"
                target="_blank"
                style={{
                  color: colors.MAIN_COLOR,
                  textDecoration: "underline",
                }}
              >
                terms of service & privacy policy.
              </a>
            </h3>
          </FieldHead>
          <div className="field-text">
            {["super_admin", "enterprise_admin", "pro"].includes(
              permissionRole
            ) ? (
              <Field
                name='terms_text'
                component={ChannelInputField}
                label='custom terms'
                placeholder={`Leave blank to use only Movebooth's standard guest terms.`}
                type='text'
                multiline={5}
                value={termsText}
              />
            ) : (
              <div style={{ marginTop: "20px" }}>
                <UpgradeButtonLinkContainer>
                  <UpgradeButtonLink href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd Like to upgrade to add custom guest terms!" target="_blank"  rel="noreferrer noopener">
                    Upgrade to add custom guest terms
                  </UpgradeButtonLink>
                </UpgradeButtonLinkContainer>
              </div>
            )}
          </div>
        </ChannelFormSection>
      </FormGroup>
      <Divider marginBottom={48}></Divider>
      <UpgradeText className='left-pos pdd-20'>
        Looking for more? Send us a suggestion.
      </UpgradeText>
      <div className='channel-forms__group'>
        <Button type='submit' onClick={notify} disabled={submitting}>
          {edit ? 'Save' : 'Save & Finish'}
        </Button>
      </div>
    </StyledForm>
  );
};

const selector = formValueSelector('channelForm');
const mapStateToProps = (state) => {
  return ({
    termsText: selector(state, "terms_text")
  });
}

export default connect(mapStateToProps)(TermsForm);


// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/Forms/TermsForm.js